export default __webpack_public_path__ + "static/media/2,blur.4705ea00.jpg";